import React from 'react'
import { Modal } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface Props {
    devices: any[]
}

const Component: React.FC<Props> = (props) => {
    const [visible, setVisible] = React.useState(false)

    const showModal = () => {
        setVisible(true)
    }

    const cancel = () => {
        setVisible(false)
    }

    return (
        <div>
            <QuestionCircleOutlined onClick={showModal} />
            <Modal
                title="Device List"
                visible={visible}
                onOk={cancel}
                onCancel={cancel}
                bodyStyle={{ height: '500px', overflow: 'scroll' }}
            >
                <div>
                    {props.devices.map((row, index) => (
                        <div key={`modal-title-${index}`}>{row.title}</div>
                    ))}
                </div>
            </Modal>
        </div>
    )
}

export default Component
